import { Loader } from '@/components/loading/Loading';
import { cn } from '@/lib/utils';
import clsx from 'clsx';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';
import { ButtonVariant, buttonClassName } from './buttonHelper';

export interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
  className?: string;
  variant?: ButtonVariant;
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  loading?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

export const Button: FC<PropsWithChildren<ButtonProps>> = ({
  children,
  className,
  variant,
  loading,
  type = 'button',
  ...props
}) => {
  return (
    <button type={type} className={cn(buttonClassName(variant), className)} {...props}>
      {loading ? (
        <span
          className={clsx(
            'flex items-center justify-center',
            variant === ButtonVariant.Primary && 'bg-primary-700',
            !variant && 'bg-primary-std'
          )}
        >
          <Loader className="h-6 w-6" />
        </span>
      ) : (
        children
      )}
    </button>
  );
};
